import { takeFiveRoute, takeFiveOverviewPathRoute, takeFivePathRoute, takeFiveSectionPathRoute, takeFiveDetailsPathRoute } from "./TakeFiveRoutes";

export const allTakeFiveRoutes = (): any[] => {
    const routes = [
        takeFiveRoute,
        takeFiveSectionPathRoute,
        takeFiveOverviewPathRoute,
        takeFivePathRoute,
        takeFiveDetailsPathRoute
    ];
    return routes;
};